import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["duration"];
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const TaskDuration = _ref => {
  let {
      duration
    } = _ref,
    otherProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (!duration) {
    return null;
  }
  return /*#__PURE__*/_jsx(Text, Object.assign({
    "data-test-id": "task-duration",
    use: "help"
  }, otherProps, {
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.checklist.shortCompletionTimeEstimate",
      options: {
        count: duration
      }
    })
  }));
};
export default TaskDuration;